<template>
  <div class="query">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              fixed
              title="我报备的客户"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--搜索-->
    <van-search v-model="searchQuery" placeholder="请输入搜索客户姓名" />
    <!--列表-->
     <template>
     <div class="van-card" v-for="(item,index) in filterItems()" :key="item.id"  @click="goUrl('/user/reportdetail/'+item.id)">
       <div class="van-card__header">
         <div class="van-card__content">
           <div>
             <div class="van-card__title van-multi-ellipsis--l2">姓名：{{item.name}}</div>
             <div class="van-card__desc van-ellipsis">电话或微信号：{{item.phone}}</div>
             <div class="van-card__desc van-ellipsis">加盟代理意向：{{item.xuqiu}}万</div>
             <div class="van-card__desc van-ellipsis">报备人：{{item.user_id}}</div>
             <div class="van-card__desc van-ellipsis">报备日期：{{item.created_at}}</div>
           </div>
         </div>
       </div>
     </div>
     </template>

  </div>
</template>

<script>
import ls from '../../utils/localStorage.js'
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Query',
    data() {
        return {
          searchQuery:''
        };
    },
    computed: {
        ...mapState({
             person: state => state.user.user_report_list
        })
    },
    methods: {
        ...mapActions(['requestUserReportQuery']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/user'});
        },
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.person) {
            return this.person.filter(item =>
              item.name.toLowerCase().includes(query)
            )
          }
        }
    },
    components: {

    },
    mounted() {
      let vid = ls.getItem('user_info').id;
      this.requestUserReportQuery({"thit":this,"id":vid});
    },
    beforeCreate() {

    }
};
</script>

<style scoped>
.query >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.query >>> .van-nav-bar__text {
  color: #fff;
}
.query >>> .van-nav-bar__title {
  color: #fff;
}
.query >>> .van-nav-bar .van-icon {
  color: #fff;
}
.query >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
